import { useMemo } from "react";
import { CHART_PAID_OFF } from "../../../lib/constants";

export const useSingleLineChartConfig = (
  data: any,
  width?: number,
  height?: number,
  isAmount?: boolean,
) => {
  const config: any = useMemo(
    () => ({
      data,
      padding: "auto" as const,
      xField: "xAxis",
      yField: "value",
      height: height || 228,
      slider: undefined,
      color: CHART_PAID_OFF,
      width: width || 728,
      legend: false,
      areaStyle: () => ({
        fill: "l(270) 0:#ffffff 1:#3C6AB4",
      }),
      tooltip: {
        customContent: (_: any, data: any) =>
          data.length > 0
            ? `<div class="py-2 area-tooltip"><div class="text-sm w-400 pb-1">${
                data[0].data.tooltipHeader
              }</div>
                  <div class="d-flex align-center justify-space-between"><div class="d-flex align-center"><div class="mr-2 legend small all"></div><div>${data[0].data.toolTipName}:</div></div><div class="text-sm w-500">&nbsp;${isAmount ? "$" : ""}${data[0].data.value}${isAmount ? "k" : ""}</div></div></div>`
            : "",
      },
    }),
    [data, height, width, isAmount],
  );

  return { config };
};
